@if (titleTemplate()) {
  <div *transloco="let t" class="page-header-container">
    <img routerLink="/" [alt]="t('NAVIGATION.COMPANY_LOGO')" [src]="logo()" />
    <span class="divider"></span>
    <ng-container *ngTemplateOutlet="titleTemplate()" />
    <section class="actions">
      @for (template of actionsTemplates(); track $index; let last = $last) {
        <ng-container *ngTemplateOutlet="template" />
        @if (!last) {
          <span class="divider"></span>
        }
      }
    </section>
    @if (menuButtonVisible) {
      <chr-button-icon
        #navButton
        class="nav-button"
        icon="hamburger"
        palette="neutral"
        variant="invisible"
        [attr.aria-label]="navigationExpanded() ? t('NAVIGATION.ARIA.BUTTONS.CLOSE_MENU') : t('NAVIGATION.ARIA.BUTTONS.HAMBURGER')"
        [attr.aria-expanded]="navigationExpanded()"
        (chr-action)="toggleAppNavigation()"
      />
    }
  </div>
}
